import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { DashboardLayout } from '../../components/DashboardLayout';
import { PageIndices } from '../../common/i-doc/i-doc.registry.ts';
import { getInvitePreview, acceptInvite } from '../../services/questionnaires/questionnaire.service';
import { toastService } from '../../services/toast.service';

const SurveyInvitePage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [accepting, setAccepting] = useState(false);
  const [preview, setPreview] = useState<{ templateId: number; name: string; description: string } | null>(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!token) return;
    getInvitePreview(token)
      .then((data) => {
        if (data) {
          setPreview(data);
        } else {
          setNotFound(true);
        }
      })
      .finally(() => setLoading(false));
  }, [token]);

  const handleAccept = async () => {
    if (!token) return;
    setAccepting(true);
    try {
      const { templateId } = await acceptInvite(token);
      navigate(`/questionnaires/${templateId}`);
    } catch {
      toastService.error('Не вдалося прийняти запрошення');
      setAccepting(false);
    }
  };

  return (
    <DashboardLayout>
      <Box data-i-doc={PageIndices.SURVEY_INVITE} sx={{ maxWidth: 480, mx: 'auto', mt: 6, textAlign: 'center' }}>
        {loading ? (
          <CircularProgress />
        ) : notFound || !preview ? (
          <>
            <Typography variant="h6" gutterBottom>Посилання недійсне</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Запрошення вже використане, скасоване або не існує.
            </Typography>
            <Button variant="outlined" onClick={() => navigate('/dashboard')}>На головну</Button>
          </>
        ) : (
          <>
            <Typography variant="h6" gutterBottom>{preview.name || 'Опитувальник'}</Typography>
            {preview.description && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                {preview.description}
              </Typography>
            )}
            <Typography variant="body2" sx={{ mb: 3 }}>
              Вас запросили пройти це опитування. Прийняти запрошення?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <Button variant="outlined" onClick={() => navigate('/dashboard')} disabled={accepting}>
                Відмовитись
              </Button>
              <Button variant="contained" onClick={handleAccept} disabled={accepting}>
                {accepting ? <CircularProgress size={20} /> : 'Прийняти'}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default SurveyInvitePage;
